import React, { useState, useEffect } from "react";
import "./solutions.css";
import { content } from "../../content/landingContent";

const Solutions = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { heading, slides: boxData } = content.solutions;

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % boxData.length);
    }, 6000);

    return () => clearInterval(timer);
  }, [boxData.length]);

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section id="solutions">
      <div className="s">
        <div className="s-heading">{heading}</div>
        <div className="s-slides">
          {boxData.map((box, index) => (
            <div
              key={box.title}
              className="s-box"
              style={{
                transform: `translateX(${-100 * currentSlide}%)`,
              }}
            >
              <ul className="s-description">
                <div>
                  <div className="s-title">{box.title}</div>
                  {box.desc.map((item, i) => (
                    <li className="s-list" key={i}>
                      {item}
                    </li>
                  ))}
                </div>
                <img src={box.image} alt={box.title} className="s-image" />
              </ul>
            </div>
          ))}
        </div>
        <div className="carousel-dots">
          {boxData.map((box, index) => (
            <div
              key={box.title}
              className={`dot ${index === currentSlide ? "active" : ""}`}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
